import React, {useCallback, useEffect, useState} from 'react'
import 'config/leaflet';
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFMember} from 'module/CustomField/type/CFType'
import FontAwesome from 'react-fontawesome'
import GPSComponent, {MapType} from 'module/CustomField/component/input/GPSComponent'
import {LeafletMouseEvent} from 'leaflet'
import './GPSComponent.css'
import {CF} from 'module/CustomField/util/CustomField'
import {fetchGeoLocation} from 'module/module/geo/fetchGeoLocation'
import {toastWarn} from 'module/Error/Toast'
import Tooltip from '@mui/material/Tooltip'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'

export function CustomFieldGPSLeafComponent({cfDef, modelValue, disabled, setCb, removeCb}: CFComponentProps<CFMember>) {
	const [{lat, lon, acc}, setLatLon] = useState<{ lat: number | undefined, lon: number | undefined, acc: number | undefined }>({lat: modelValue.lat, lon: modelValue.lon, acc: modelValue.acc});
	const isRequired = cfDef.required;
	const [mapViewControl, setMapViewControl] = useState<boolean>(cfDef.cfAttrs.find(cfa => cfa.key === 'mapViewControl')?.value === 'J');
	const [locating, setLocating] = useState<boolean>(false);
	const [maptype, setMaptype] = useState<MapType>('roadmap');
	const googleLinkControl: boolean = CF.getCFAttr(cfDef, CFAttrKey.googleLinkControl)?.value === 'J';
	const googleLinkUrl: string | undefined = CF.getCFAttr(cfDef, CFAttrKey.googleLinkUrl)?.value;
	const linkToGoogleMap: boolean | string | undefined = googleLinkControl && googleLinkUrl;
	const fullscreenControl: boolean = CF.getCFAttr(cfDef, CFAttrKey.fullscreenControl)?.value === 'J';
	const attributionControl: boolean = CF.getCFAttr(cfDef, CFAttrKey.attributionControl)?.value === 'J';
	const switchMaptypeControl: boolean = CF.getCFAttr(cfDef, CFAttrKey.switchMaptypeControl)?.value === 'J';
	const zoom: string | undefined = CF.getCFAttr(cfDef, CFAttrKey.zoom)?.value;
	const showAccuracy: boolean = CF.getCFAttr(cfDef, CFAttrKey.showAccuracy)?.value === 'J';
	let noGpsData = (!lat || !lon);

	const onChange = useCallback((event: LeafletMouseEvent) => {
		const {latlng: {lat, lng}} = event;
		setCb({lat: lat, lon: lng, acc: 1});
	}, []);

	const switchMaptype = useCallback(() => {
		if (maptype === 'roadmap') {
			setMaptype('satellite');
		} else if (maptype === 'satellite') {
			setMaptype('roadmap');
		}
	}, [maptype]);

	const setCurrentPosition = () => {
		setLocating(true);
		fetchGeoLocation().then(({coords: {accuracy, longitude, latitude}}) => {
			setCb({lat: latitude, lon: longitude, acc: accuracy})
			setLocating(false)
		}).catch((error) => {
			toastWarn(error, "gpsWarn", {autoClose: 3000})
			setLocating(false);
		})
	}

	useEffect(() => {
		setLatLon({lat: modelValue.lat, lon: modelValue.lon, acc: modelValue.acc});
	}, [modelValue]);

	return <div className={'CustomFieldComponentBorder'}>
		<table className={'GPSComponent GPSComponentTable'}>
			<tbody>
			<tr>
				<td>
					{
						locating &&
						<div className={'GPSComponentWrapper '} style={{cursor: 'pointer'}}>
							<FontAwesome className={"GPSComponentWrapper-Fade-Rotate"} name={"compass"} size={'3x'}/>
						</div>
						||
						(mapViewControl &&
							<div className={'GPSComponentWrapper'}>
								{
									noGpsData &&
									<div className={'GPSComponentWrapper '}>
										<h4>Keine GPS Koordinaten</h4>
									</div> ||
									<GPSComponent
										lat={lat}
										lon={lon}
										disabled={disabled}
										acc={acc}
										showAccuracy={showAccuracy}
										onChange={onChange}
										fullscreenControl={fullscreenControl}
										attributionControl={attributionControl}
										maptype={maptype}
										zoom={zoom && parseInt(zoom) || 13}
									/>
								}
							</div> ||
							<div className={'GPSComponentWrapper'}>
								{
									noGpsData &&
									<div className={'GPSComponentWrapper '}>
										<h4>Keine GPS Koordinaten</h4>
									</div> ||
									(linkToGoogleMap && <a href={linkToGoogleMap + encodeURIComponent(lat + ',' + lon)} target={'_blank'}>
										<span>{lat}, {lon}</span>
									</a> || <a href={'#'} onClick={() => setMapViewControl(true)}>
										<span>{lat}, {lon}</span>
									</a>)
								}
							</div>)
					}
				</td>
				<td className={'GPSComponentButtonColumn'}>
					<div className={'GPSComponentButtonColumn-Inner'}>
						{
							<Tooltip title={"Karte / Koordinaten"} placement={'top'}>
								<div className={'GPSComponentButton'} onClick={() => setMapViewControl(!mapViewControl)}>
									<FontAwesome name={"globe"} size={'2x'}/>
								</div>
							</Tooltip>
						}
						{
							switchMaptypeControl && <Tooltip title={"Map-View"} placement={'top'}>
								<div className={'GPSComponentButton'} onClick={() => switchMaptype()}>
									<FontAwesome name={"map"} size={'2x'}/>
								</div>
							</Tooltip>
						}
						<Tooltip title={"Position neu bestimmen"} placement={'top'}>
							<div className={'GPSComponentButton'} onClick={setCurrentPosition}>
								{
									!disabled && <FontAwesome name={"map-marker"} size={'2x'}/>
								}
							</div>
						</Tooltip>
						{
							!isRequired &&
							<Tooltip title={"GPS Daten löschen"} placement={'top'}>
								<div className={'GPSComponentButton'} onClick={removeCb}>
									{!disabled && <FontAwesome name={"times"} size={'2x'}/>}
								</div>
							</Tooltip>
						}
					</div>
				</td>
			</tr>
			</tbody>
		</table>
	</div>
}


